import {FETCH_PROFILE_DATA_REQUEST, FETCH_PROFILE_DATA_SUCCESS, FETCH_PROFILE_DATA_FAILURE} from '../constants';

// export const fetchProfileDataRequest = () => {
//   // console.log("Saga is called");
//   return {
//   type: FETCH_PROFILE_DATA_REQUEST,
// }};

export const fetchProfileDataRequest = (studentId) => ({
  type: FETCH_PROFILE_DATA_REQUEST,
  payload: { studentId },
});


export const fetchProfileDataSuccess = (data) => ({
  type: FETCH_PROFILE_DATA_SUCCESS,
  payload: data,
});

export const fetchProfileDataFailure = (error) => ({
  type: FETCH_PROFILE_DATA_FAILURE,
  payload: error,
});